export default {"src":"/_next/static/media/SpotIllustrationMobile.832e07b3.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};